import {
  HOME_PENCIL_BANNER_WEB,
  RECENT_ORDERS_TAB_BANNER_MWEB,
  STICKY_FOOTER_BANNER_MWEB,
  TOP_BANNER_MWEB,
} from "./brazePlacementIds";
import {
  setNavHeightCssVars,
  setTopBannerDesktopHeightCssVar,
  setTopBannerMobileLayout,
} from "./navHeightCssVars";
import {
  RECENT_ORDERS_TAB_BANNER_HEIGHT_CSS_VAR,
  STICKY_FOOTER_BANNER_HEIGHT_CSS_VAR,
} from "../constants/layoutHeights";

export type BrazeBannerLayoutEntry = {
  cssVar?: string;
  applyLayout?: (heightPx: number) => void;
  clearLayout?: () => void;
};

function setRootCssVar(cssVar: string, heightPx: number): void {
  document.documentElement.style.setProperty(
    cssVar,
    heightPx > 0 ? `${heightPx}px` : "0px"
  );
}

function entryWithCssVar(cssVar: string): BrazeBannerLayoutEntry {
  return {
    cssVar,
    applyLayout: (heightPx) => setRootCssVar(cssVar, heightPx),
    clearLayout: () => setRootCssVar(cssVar, 0),
  };
}

/**
 * Placements that write measured heights to global CSS layout vars.
 * Inline-only slots omit registry entries — height stays on the slot element.
 */
export const BRAZE_BANNER_LAYOUT_REGISTRY: Record<
  string,
  BrazeBannerLayoutEntry
> = {
  [TOP_BANNER_MWEB]: {
    applyLayout: setTopBannerMobileLayout,
    clearLayout: () => setTopBannerMobileLayout(0),
  },
  [STICKY_FOOTER_BANNER_MWEB]: entryWithCssVar(
    STICKY_FOOTER_BANNER_HEIGHT_CSS_VAR
  ),
  [RECENT_ORDERS_TAB_BANNER_MWEB]: entryWithCssVar(
    RECENT_ORDERS_TAB_BANNER_HEIGHT_CSS_VAR
  ),
  [HOME_PENCIL_BANNER_WEB]: {
    applyLayout: (heightPx) => {
      setNavHeightCssVars(heightPx, ["desktop", "generic"]);
      setTopBannerDesktopHeightCssVar(heightPx);
    },
    clearLayout: () => {
      setNavHeightCssVars(0, ["desktop", "generic"]);
      setTopBannerDesktopHeightCssVar(0);
    },
  },
};

export function getBannerLayoutEntry(
  placementId: string
): BrazeBannerLayoutEntry | undefined {
  return BRAZE_BANNER_LAYOUT_REGISTRY[placementId];
}
